const JARO_WINKLER_P = 0.1;
const JARO_WINKLER_MAX_L = 4;
export const jaroWinklerDistance = (s1) => (s2) => {
    if (s1 === s2) {
        return 1;
    }
    if (!s1 || !s2) {
        return 0;
    }
    const { m, s1Matches, s2Matches } = computeM(s1, s2);
    if (m === 0) {
        return 0;
    }
    const t = computeT(s1, s2, { s1Matches, s2Matches });
    const jaroWeight = (m / s1.length + m / s2.length + (m - t / 2) / m) / 3;
    const winklerWeight = jaroWeight > 0.7 ? computePrefixL(s1, s2) * JARO_WINKLER_P : 0;
    return jaroWeight + winklerWeight * (1 - jaroWeight);
};
function computeM(s1, s2) {
    const range = Math.max(0, Math.floor(Math.max(s1.length, s2.length) / 2) - 1);
    const s1Matches = Array.from({ length: s1.length });
    const s2Matches = Array.from({ length: s2.length });
    let m = 0;
    for (let i = 0; i < s1.length; i++) {
        const low = Math.max(0, i - range);
        const high = Math.min(i + range, s2.length - 1);
        for (let j = low; j <= high; j++) {
            if (s1Matches[i] || s2Matches[j] || s1[i] !== s2[j]) {
                continue;
            }
            m++;
            s1Matches[i] = true;
            s2Matches[j] = true;
        }
    }
    return { m, s1Matches, s2Matches };
}
function computeT(s1, s2, { s1Matches, s2Matches }) {
    let t = 0;
    for (let i = 0, k = 0; i < s1.length; i++) {
        if (!s1Matches[i]) {
            continue;
        }
        let j = k;
        for (; j < s2.length; j++) {
            if (s2Matches[j]) {
                k = j + 1;
                break;
            }
        }
        if (s1[i] !== s2[j]) {
            t++;
        }
    }
    return t;
}
function computePrefixL(s1, s2) {
    let prefixL = 0;
    while (s1[prefixL] === s2[prefixL] && prefixL < JARO_WINKLER_MAX_L) {
        prefixL++;
    }
    return prefixL;
}
//# sourceMappingURL=jaroWinklerDistance.js.map